import { useEffect } from 'react';

const useAsyncEffect = (asyncEffect, deps) => {
  useEffect(() => {
    asyncEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export { useAsyncEffect };